// Copyright (c) 2016 Deere & Company

import LaborAdditiveContainer from '../../pip/labor-additive/components';

export default {
    component: LaborAdditiveContainer,
    name: 'LABOR_ADDITIVE',
    path: 'labor-additive'
};



// WEBPACK FOOTER //
// ./src/routes/pips/labor-additive.js